import React from 'react';
import { View, Pressable } from 'react-native';
import styled from 'styled-components/native';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareXmark } from '@fortawesome/free-solid-svg-icons';

import webStyled from 'styled-components';

import { Text } from 'src/styles';
import { PrimaryButton, SecondaryButton } from './buttons';
import {
  DefaultModal,
  CenteredView,
  ModalView,
  ModalHeader,
  HeaderText,
  CancelX,
} from './NativeModal/elements';

// Built from NativeModal's primitives rather than NativeModal itself: its
// ModalContent floors at min-width 600px, which overflows a phone.
const Content = styled(View)`
  margin-left: 20px;
  margin-right: 20px;
  margin-bottom: 20px;
  max-width: 420px;
`;

const Message = styled(Text)`
  font-size: 16px;
  margin-bottom: 20px;
`;

// Not elements/buttons' ButtonGroup: that is web styled-components wrapped
// around a react-native View, so its flex rules never reach the DOM.
const Actions = webStyled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 12px;

  @media (max-width: 480px) {
    flex-direction: column-reverse;
  }
`;

const ConfirmDialog = ({
  open,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  onConfirm,
  onCancel,
}) => (
  <DefaultModal visible={open} transparent onRequestClose={onCancel}>
    <CenteredView>
      <ModalView onPress={() => false}>
        <ModalHeader>
          <HeaderText>{title}</HeaderText>
          <Pressable onPress={onCancel}>
            <CancelX>
              <FontAwesomeIcon
                icon={faSquareXmark}
                size="lg"
                style={{ color: '#fff' }}
              />
            </CancelX>
          </Pressable>
        </ModalHeader>
        <Content>
          <Message>{message}</Message>
          <Actions>
            <SecondaryButton small onClick={onCancel}>
              {cancelLabel}
            </SecondaryButton>
            <PrimaryButton small onClick={onConfirm}>
              {confirmLabel}
            </PrimaryButton>
          </Actions>
        </Content>
      </ModalView>
    </CenteredView>
  </DefaultModal>
);

export default ConfirmDialog;
